<nav class="navbar navbar-expand-lg navbar-dark bg-opacity" [style.background]="headerColor" style="z-index: 999">
  <div class="container-fluid">
    <img style="padding: 0px" src="assets/basf.svg" width="80" height="50" alt="BASF logo 'We create chemistry'" />

    <a class="navbar-brand project-title" href="#">{{ app }}</a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item active">
          <a href="#">
            <button data-cy="dashboard" matTooltip="Dashboard" class="top-bar-btn" mat-icon-button>
              <mat-icon style="color: white; margin-left: 10px; margin-right: 10px; transform: rotate(180deg)">
                dashboard_customize
              </mat-icon>
            </button>
          </a>
        </li>
        <li *ngIf="contacts > 0" class="nav-item active">
          <button matTooltip="Notifications" (click)="openSidebar()" mat-icon-button>
            <mat-icon
              [matBadge]="contacts"
              matBadgeColor="warn"
              matBadgeSize="small"
              style="color: white; margin-left: 10px; margin-right: 10px"
            >
              notifications
            </mat-icon>
          </button>
        </li>
        <li class="nav-item active">
          <button matTooltip="Contacts" (click)="openContacts()" mat-icon-button data-cy="contacts">
            <mat-icon style="color: white; margin-left: 10px; margin-right: 10px">people</mat-icon>
          </button>
        </li>
        <li class="nav-item active">
          <div mat-button [matMenuTriggerFor]="more_menu" style="cursor: pointer">
            <button matTooltip="More" mat-icon-button>
              <mat-icon style="color: white; margin-left: 10px; margin-right: 10px">more_vert</mat-icon>
            </button>
            <div style="display: inline-block">
              <mat-menu #more_menu="matMenu">
                <button mat-menu-item (click)="openHomeApp()">
                  <mat-icon style="font-size: 20px; margin-right: 5px; color: #373737">home</mat-icon>
                  {{ app }} home
                </button>
                <button mat-menu-item (click)="openCms()">
                  <mat-icon style="font-size: 20px; margin-right: 5px; color: #373737">public</mat-icon>
                  Ultrasimweb
                </button>
                <button matTooltip="E-Mail us" (click)="mailMe()" mat-menu-item>
                  <mat-icon style="font-size: 20px; margin-right: 5px; color: #373737">email</mat-icon>
                  Contact us
                </button>
              </mat-menu>
            </div>
          </div>
        </li>
        <li class="nav-item" style="margin-left: 15px; margin-right: 5px">
          <div *ngIf="fullName" class="vl-line"></div>
        </li>
        <li class="nav-item">
          <div
            *ngIf="fullName"
            mat-button
            [matMenuTriggerFor]="menu"
            style="cursor: pointer; margin-top: 10px; margin-left: 10px"
          >
            <div style="display: inline-block; margin-right: 10px">
              <p style="color: white">{{ fullName }}</p>
            </div>
            <div style="display: inline-block">
              <!-- color: rgb(101, 172, 30) background-color: white -->
              <span style="cursor: pointer" [style.background]="mainColor" class="i-circle">{{ initial }}</span>
              <mat-menu #menu="matMenu">
                <button *ngIf="app === 'Foaming'" (click)="openCredits()" mat-menu-item>
                  <mat-icon style="font-size: 20px; margin-right: 5px">attach_money</mat-icon>
                  Credits
                </button>
                <button (click)="logout()" mat-menu-item>
                  <mat-icon style="font-size: 20px; margin-right: 5px">logout</mat-icon>
                  Logout
                </button>
              </mat-menu>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
